import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { getTranslation, logError } from "../helpers/utils";

export const getPages = createAsyncThunk(
  "PageSlice/getPages",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_LOCAL_API}/pages`
      );
      return { langId: data.selLanguageId, res: response.data.data.Pages };
    } catch (error) {
      logError(error, "PageSlice/getPages");
      return rejectWithValue(error.response.data);
    }
  }
);

export const PageSlice = createSlice({
  name: "pages",
  initialState: {
    pages: [],
    backToGuide: false,
    backFromSettings: "HumQadam",
  },
  reducers: {
    setBackToGuide: (state, action) => {
      state.backToGuide = action.payload;
    },
    setBackFromSettings: (state, action) => {
      state.backFromSettings = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPages.fulfilled, (state, action) => {
        const active = (action.payload.res || []).filter((p) => p.deleted_at == null);
        state.pages = active.map((lang) => {
          let trans = { ...lang };
          const isEnglish = (t) =>
            (t?.language?.code && String(t.language.code).toLowerCase() === "en") ||
            (t?.language?.language && String(t.language.language).toLowerCase() === "english");
          trans.key = lang.title.find(isEnglish)?.text ?? lang.title?.[0]?.text ?? "";
          trans.title = getTranslation(lang.title, action.payload.langId);
          trans.description = getTranslation(
            lang.description,
            action.payload.langId
          );
          return trans;
        });
      })
      .addCase(getPages.rejected, (state, action) => {
        toast.error(action.payload);
      });
  },
});
export const { setBackToGuide, setBackFromSettings } = PageSlice.actions;

export default PageSlice.reducer;
